import { create } from "zustand"

const VERIFICATION_SUCCESS_GRACE_MS = 5000

interface State {
  state:
    | "unverified"
    | "need-verification"
    | "verified"
    | "blocked"
    | "unauthorized"
  preventRedirect: boolean
  ignoreNeedVerificationUntil: number
  returnPath: string | null
}

interface Actions {
  updateState: (state: State["state"]) => void
  setPreventRedirect: (preventRedirect: boolean) => void
  markVerificationSucceeded: () => void
  shouldIgnoreNeedVerification: () => boolean
  setReturnPath: (returnPath: string) => void
  clearReturnPath: () => void
}

const initialState: State = {
  state: "unverified",
  preventRedirect: false,
  ignoreNeedVerificationUntil: 0,
  returnPath: null,
}

const usePermissionValidatorStore = create<State & Actions>()((set, get) => ({
  ...initialState,
  updateState: (state) => set({ state }),
  setPreventRedirect: (preventRedirect) => set({ preventRedirect }),
  markVerificationSucceeded: () =>
    set({
      ignoreNeedVerificationUntil: Date.now() + VERIFICATION_SUCCESS_GRACE_MS,
    }),
  shouldIgnoreNeedVerification: () =>
    Date.now() < get().ignoreNeedVerificationUntil,
  setReturnPath: (returnPath) => set({ returnPath }),
  clearReturnPath: () => set({ returnPath: null }),
}))

export { usePermissionValidatorStore }
